export enum OrganizationType {
  DEVELOPMENT = 'DEVELOPMENT',
  DESIGN = 'DESIGN',
  CONSTRUCTION = 'CONSTRUCTION',
  SUPERVISE = 'SUPERVISE',
  SPOT_CHECK = 'SPOT_CHECK',
  JG_CHECK = 'JG_CHECK',
  COMPLETED_CHECK = 'COMPLETED_CHECK',
  AUDIT = 'AUDIT',
  MONITOR = 'MONITOR',
  SURVEYOR = 'SURVEYOR',
  CONSULTANCY = 'CONSULTANCY',
  OPERATE = 'OPERATE',
  ALL = 'ALL',
}

export const OrganizationTypeOrderList = [
  OrganizationType.DEVELOPMENT,
  OrganizationType.DESIGN,
  OrganizationType.CONSTRUCTION,
  OrganizationType.SUPERVISE,
  OrganizationType.SPOT_CHECK,
  OrganizationType.JG_CHECK,
  OrganizationType.COMPLETED_CHECK,
  OrganizationType.AUDIT,
  OrganizationType.MONITOR,
  OrganizationType.SURVEYOR,
  OrganizationType.CONSULTANCY,
  OrganizationType.OPERATE,
  OrganizationType.ALL,
];

export const OrganizationTypeMap = {
  [OrganizationType.DEVELOPMENT]: '建设单位',
  [OrganizationType.DESIGN]: '设计单位',
  [OrganizationType.CONSTRUCTION]: '施工单位',
  [OrganizationType.SUPERVISE]: '监理单位',
  [OrganizationType.SPOT_CHECK]: '中心实验室',
  [OrganizationType.JG_CHECK]: '交工检测单位',
  [OrganizationType.COMPLETED_CHECK]: '竣工检测单位',
  [OrganizationType.AUDIT]: '审计单位',
  [OrganizationType.MONITOR]: '施工监控单位',
  [OrganizationType.SURVEYOR]: '监测单位',
  [OrganizationType.CONSULTANCY]: '咨询单位',
  [OrganizationType.OPERATE]: '运营单位',
  [OrganizationType.ALL]: '综合',
};

export const OrganizationTypeList = [
  {
    value: OrganizationType.DEVELOPMENT,
    label: OrganizationTypeMap[OrganizationType.DEVELOPMENT],
  },
  {
    value: OrganizationType.DESIGN,
    label: OrganizationTypeMap[OrganizationType.DESIGN],
  },
  {
    value: OrganizationType.CONSTRUCTION,
    label: OrganizationTypeMap[OrganizationType.CONSTRUCTION],
  },
  {
    value: OrganizationType.SUPERVISE,
    label: OrganizationTypeMap[OrganizationType.SUPERVISE],
  },
  {
    value: OrganizationType.SPOT_CHECK,
    label: OrganizationTypeMap[OrganizationType.SPOT_CHECK],
  },
  {
    value: OrganizationType.JG_CHECK,
    label: OrganizationTypeMap[OrganizationType.JG_CHECK],
  },
  {
    value: OrganizationType.COMPLETED_CHECK,
    label: OrganizationTypeMap[OrganizationType.COMPLETED_CHECK],
  },
  {
    value: OrganizationType.AUDIT,
    label: OrganizationTypeMap[OrganizationType.AUDIT],
  },
  {
    value: OrganizationType.MONITOR,
    label: OrganizationTypeMap[OrganizationType.MONITOR],
  },
  {
    value: OrganizationType.SURVEYOR,
    label: OrganizationTypeMap[OrganizationType.SURVEYOR],
  },
  {
    value: OrganizationType.CONSULTANCY,
    label: OrganizationTypeMap[OrganizationType.CONSULTANCY],
  },
  {
    value: OrganizationType.OPERATE,
    label: OrganizationTypeMap[OrganizationType.OPERATE],
  },
  {
    value: OrganizationType.ALL,
    label: OrganizationTypeMap[OrganizationType.ALL],
  },
];

export const OrganizationTypeShortMap = {
  [OrganizationType.DEVELOPMENT]: '建设',
  [OrganizationType.DESIGN]: '设计',
  [OrganizationType.CONSTRUCTION]: '施工',
  [OrganizationType.SUPERVISE]: '监理',
  [OrganizationType.SPOT_CHECK]: '试验',
  [OrganizationType.JG_CHECK]: '交工',
  [OrganizationType.COMPLETED_CHECK]: '竣工',
  [OrganizationType.OPERATE]: '运营',
  [OrganizationType.AUDIT]: '审计',
  [OrganizationType.MONITOR]: '施工监控',
  [OrganizationType.SURVEYOR]: '监测',
  [OrganizationType.CONSULTANCY]: '咨询',
  [OrganizationType.ALL]: '综合',
};

export const OrganizationTypeShortList = [
  {
    value: OrganizationType.DEVELOPMENT,
    label: OrganizationTypeShortMap[OrganizationType.DEVELOPMENT],
  },
  {
    value: OrganizationType.DESIGN,
    label: OrganizationTypeShortMap[OrganizationType.DESIGN],
  },
  {
    value: OrganizationType.CONSTRUCTION,
    label: OrganizationTypeShortMap[OrganizationType.CONSTRUCTION],
  },
  {
    value: OrganizationType.SUPERVISE,
    label: OrganizationTypeShortMap[OrganizationType.SUPERVISE],
  },
  {
    value: OrganizationType.SPOT_CHECK,
    label: OrganizationTypeShortMap[OrganizationType.SPOT_CHECK],
  },
  {
    value: OrganizationType.JG_CHECK,
    label: OrganizationTypeShortMap[OrganizationType.JG_CHECK],
  },
  {
    value: OrganizationType.COMPLETED_CHECK,
    label: OrganizationTypeShortMap[OrganizationType.COMPLETED_CHECK],
  },
  {
    value: OrganizationType.AUDIT,
    label: OrganizationTypeShortMap[OrganizationType.AUDIT],
  },
  {
    value: OrganizationType.MONITOR,
    label: OrganizationTypeShortMap[OrganizationType.MONITOR],
  },
  {
    value: OrganizationType.SURVEYOR,
    label: OrganizationTypeShortMap[OrganizationType.SURVEYOR],
  },
  {
    value: OrganizationType.CONSULTANCY,
    label: OrganizationTypeShortMap[OrganizationType.CONSULTANCY],
  },
  {
    value: OrganizationType.OPERATE,
    label: OrganizationTypeShortMap[OrganizationType.OPERATE],
  },
  {
    value: OrganizationType.ALL,
    label: OrganizationTypeShortMap[OrganizationType.ALL],
  },
];
